export function pushDataLayerEvent(eventData, options = {}) {
    if (!eventData || typeof eventData !== 'object' || !eventData.event) {
        if (typeof options.callback === 'function') {
            options.callback()
        }

        return false
    }

    window.dataLayer = window.dataLayer || []

    let callbackDone = false
    const timeout = Number(options.timeout || 700)
    const payload = {...eventData}

    function runCallback() {
        if (callbackDone || typeof options.callback !== 'function') {
            return
        }

        callbackDone = true
        options.callback()
    }

    if (typeof options.callback === 'function') {
        payload.eventCallback = runCallback
        payload.eventTimeout = timeout
    }

    window.dataLayer.push(payload)

    if (typeof options.callback === 'function') {
        window.setTimeout(runCallback, timeout)
    }

    return true
}

export function pushDataLayerEventOnce(eventData, storagePrefix = 'gtm_event') {
    if (!eventData || typeof eventData !== 'object' || !eventData.event) {
        return false
    }

    const eventKey = eventData.event_id || `${eventData.event}:${eventData.transaction_id || ''}`
    const storageKey = `${storagePrefix}:${eventKey}`

    try {
        if (window.localStorage && window.localStorage.getItem(storageKey)) {
            return false
        }

        if (window.localStorage) {
            window.localStorage.setItem(storageKey, '1')
        }
    } catch (e) {
        // Tracking should not break the payment flow if storage is blocked.
    }

    return pushDataLayerEvent(eventData)
}
